module.exports = __webpack_public_path__ + "static/media/tape.efcb5e5e.svg";